module.exports = __webpack_public_path__ + "static/img/invite6.0761154.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/invite6.png
// module id = ChCG
// module chunks = 88